'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import {filterOrganisations, loadIdList, loadMore} from "../Actions";
import ConnectedCampusFormSelect from "../../../CommonComponents/Form/ConnectedCampusFormSelect";

class ConnectedOrganisationFormSelect extends React.Component {

    render() {
        return <ConnectedCampusFormSelect
            {...this.props}
            reducerName="organisations"
            filterEntity={filterOrganisations}
            loadIdList={loadIdList}
            loadMore={loadMore}
        />
    }

}

ConnectedOrganisationFormSelect.propTypes = {
    label: PropTypes.string.isRequired,
    validationErrorMessage: PropTypes.string,
    placeHolder: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    clearable: PropTypes.bool,
    noResultsLabel: PropTypes.string,
};

ConnectedOrganisationFormSelect.defaultProps = {
    label: 'Organisation',
    placeHolder: 'Please select',
    noResultsLabel: 'No Results Found'
};

export default ConnectedOrganisationFormSelect;